/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Dateofbirth_Label2Inputs */

const en_cv_extract_form_dateofbirth_label2 = /** @type {(inputs: Cv_Extract_Form_Dateofbirth_Label2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date of birth`)
};

const de_cv_extract_form_dateofbirth_label2 = /** @type {(inputs: Cv_Extract_Form_Dateofbirth_Label2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geburtsdatum`)
};

/**
* | output |
* | --- |
* | "Date of birth" |
*
* @param {Cv_Extract_Form_Dateofbirth_Label2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cv_extract_form_dateofbirth_label2 = /** @type {((inputs?: Cv_Extract_Form_Dateofbirth_Label2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Dateofbirth_Label2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_dateofbirth_label2(inputs)
	return en_cv_extract_form_dateofbirth_label2(inputs)
});
export { cv_extract_form_dateofbirth_label2 as "cv_extract_form_dateOfBirth_label" }